import { DhtmlxScheduler } from 'cv-library-react-web';
import { themes } from 'cv-react-core';
import getTheme from '../Calendar/Calendar.theme';

export default themes.themeComponent(DhtmlxScheduler, getTheme);
